import { PodeNaoPodeEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta18ExemplosEnum,
  ConsultaSeguimentoPergunta18Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-18/model-consultaSeguimentoPergunta18'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta18Model {
  header: MchatRfAplicacaoQueryModel
  podeNaoPode: MchatRfAplicacaoQueryModel | undefined
  cenariosComDica: MchatRfAplicacaoQueryModel[]
  cenariosSemDica: MchatRfAplicacaoQueryModel[]
  perguntaAdicionalSemDica: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta18Model
}

export const convertAplicacaoPergunta18 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta18Model | null => {
  const { header, perguntas } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_18_01)

  if (isUndefinedOrNull(header)) return null

  const podeNaoPode = perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_18_02)
  const cenariosComDica = perguntas.filter((aplicacao) => PERGUNTA_18_COM_DICA.includes(aplicacao.pergunta))
  const cenariosSemDica = perguntas.filter((aplicacao) => PERGUNTA_18_SEM_DICA.includes(aplicacao.pergunta))
  const perguntaAdicionalSemDica = perguntas.find(
    (aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_18_04
  )

  return {
    header,
    podeNaoPode,
    cenariosComDica,
    cenariosSemDica,
    perguntaAdicionalSemDica,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_18_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_18_PODE_NAO_PODE: convertPodeNaoPodeEnum(podeNaoPode?.stPassou),
      PERGUNTA_18_TEM_DICA_SEGUE_ORDEM: booleanToSimNaoEnum(
        cenariosComDica.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_18_03)?.stPassou
      ),
      PERGUNTA_18_SENTA_A_MESA: booleanToSimNaoEnum(perguntaAdicionalSemDica?.stPassou),
      PERGUNTA_18_EXEMPLOS: convertAplicacoesToExemplos(cenariosSemDica),
    },
  }
}

const convertPodeNaoPodeEnum = (stPassou: boolean | null | undefined): PodeNaoPodeEnum | undefined => {
  if (isUndefinedOrNull(stPassou)) return undefined
  return stPassou ? PodeNaoPodeEnum.PODE : PodeNaoPodeEnum.NAO_PODE
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta18ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta18ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const cenario = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (cenario) {
        acc[cenario] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const PERGUNTA_18_COM_DICA = [MChatPerguntaEnum.PERGUNTA_18_03]
const PERGUNTA_18_SEM_DICA = [
  MChatPerguntaEnum.PERGUNTA_18_05,
  MChatPerguntaEnum.PERGUNTA_18_06,
  MChatPerguntaEnum.PERGUNTA_18_07,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta18ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_MOSTRA_SAPATO]: undefined,
  [ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_TRAZ_COBERTOR]: undefined,
  [ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_POE_LIVRO_CADEIRA]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta18ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_18_05]: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_MOSTRA_SAPATO,
  [MChatPerguntaEnum.PERGUNTA_18_06]: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_TRAZ_COBERTOR,
  [MChatPerguntaEnum.PERGUNTA_18_07]: ConsultaSeguimentoPergunta18ExemplosEnum.SEM_DICA_POE_LIVRO_CADEIRA,
}
